import { Card } from '../../../components/ui/Card';
import { ASSESSMENT_PAUSED_MESSAGE } from './assessmentPaused';

// Increment C: a suspended company's respondents are paused; their answers are kept.

export default function AssessmentPausedNotice() {
  return (
    <div className="min-h-screen bg-[rgba(255,255,255,0.03)] flex items-center justify-center">
      <Card className="max-w-md w-full mx-4">
        <Card.Body className="text-center">
          <div aria-hidden="true" className="text-4xl text-[#a8b2d1] mb-4">⏸</div>
          <h3 className="text-lg font-semibold text-[#e6f1ff] mb-2">Assessment paused</h3>
          <p role="status" className="text-[#a8b2d1]">{ASSESSMENT_PAUSED_MESSAGE}</p>
        </Card.Body>
      </Card>
    </div>
  );
}
